// components/Header.js
import React from "react";
import { fontSizes, layout, buttons, rounded } from "../styles/tokens";
import {
  IconDeviceFloppy, // Video Load
  IconSlice,        // Quick Add / Slicer
  IconMetronome,    // Metronome
  IconFolder,       // Bookmark Manager
} from "@tabler/icons-react";

export default function Header({
  user,
  onLogin,
  onLogout,
  onShowEmailLogin,
  onToggleGuide,
  onToggleFilePanel,
  onShowVideoLoad,
  onShowMetronome,
  onShowQuickAdd,
  activeTopSection,
  onShowLoginOptions,
}) {
  // Use a stable id (must match what App.js sets in setActiveTopSection)
  const navButtons = [
    { id: "Video Load",        label: "Video Load",       onClick: onShowVideoLoad,   Icon: IconDeviceFloppy },
    { id: "Quick Add",         label: "Slicer",           onClick: onShowQuickAdd,    Icon: IconSlice },
    { id: "Metronome",         label: "Metronome",        onClick: onShowMetronome,   Icon: IconMetronome },
    { id: "Bookmark Manager",  label: "Bookmark Manager", onClick: onToggleFilePanel, Icon: IconFolder },
  ];

  const navBtnBase =
    `group inline-flex items-center justify-center gap-2
     ${rounded.full} h-9 px-3 text-sm leading-none transition-colors`;

  return (
    <header className={layout.header}>
      {/* Top row: Title + Login */}
      <div className={`${layout.headerTopRow} ${layout.container}`}>
        {/* Header title (centered logo) */}
          <div className="relative flex-1">
            <img
              src="/loopy-logo.png"
              alt="Loopy"
              className="mx-auto h-8 sm:h-10"
              draggable="false"
            />
          </div>


        <div className="flex items-center gap-2">
          {user ? (
            <>
              <span className={`${fontSizes.base} hidden sm:inline`}>{user.displayName}</span>
              <button onClick={onLogout} className={buttons.whitePurple}>Logout</button>
            </>
          ) : (
            <button onClick={onShowLoginOptions} className={buttons.whitePurple}>Login</button>
          )}
        </div>
      </div>

      {/* Second row: Nav buttons */}
      <div className={layout.headerBottomRow}>
        {navButtons.map(({ id, label, onClick, Icon }) => {
          const isActive = activeTopSection === id;
          return (
            <button
              key={id}
              onClick={onClick}
              title={label}
              aria-label={label}
              aria-current={isActive ? "page" : undefined}
              className={`${navBtnBase} ${
                isActive
                  ? `${buttons.activePurple} text-white`      // selected: different purple bg, keep white text
                  : `${buttons.purpleHover} text-white hover:text-black` // inactive: white -> black on hover
              }`}
            >
              <Icon
                size={16}
                stroke={2}
                className={`shrink-0 ${
                  isActive ? "text-white" : "text-white group-hover:text-black"
                }`}
              />
              <span className="hidden sm:inline whitespace-nowrap">{label}</span>
            </button>
          );
        })}
      </div>
    </header>
  );
}
